// extracted by mini-css-extract-plugin
export default {"modalDialog":"styles_modalDialog__rxSXS","modalContent":"styles_modalContent__cImOR","left":"styles_left__sy+qe","right":"styles_right__+pcfu"};